import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";

export const HeaderTable = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: props.theme.candy.tables.border.color,

    td: {
        whiteSpace: "normal",
    },
}));

export const headerRowsContainer = (theme: Theme) =>
    css({
        position: "relative",
        zIndex: 106,
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
    });

export const headerRowsContainerSticky = (theme: Theme) =>
    css({
        borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
        boxShadow: `0 3px 5px 0 ${theme.candy.legacy.shadowColor}`,
    });

export const headerCaption = (theme: Theme) =>
    css({
        paddingTop: 10,
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        zIndex: 107,
        position: "relative",
    });

export const headerContainerFixed = css({
    overflow: "hidden",
    zIndex: 106,
    position: "fixed",
    top: 0,
});

export const headerContainerBottom = css({
    overflow: "hidden",
    position: "absolute",
    zIndex: 105,
    bottom: 0,
    left: 0,
});

export const headerBottomLine = (theme: Theme) =>
    css({
        borderBottom: theme.candy.tables.border.solid,
    });

export const headerNotBottomLine = (theme: Theme) =>
    css({
        borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
    });
